
//== Include script from the Global setup.
//
//##

import '../../../Global/Source/Scripts/app'


//== Include libraries.
//
//##

//import './Libraries/xxx'


//== Include stuff for extensions.
//
//##

//import './Extensions/XXX'


//== Include stuff for content elements.
//
//##

//import './ContentElements/XXX'


//== Include stuff for parts of the websites.
//
//##

//import './Parts/XXX'


//== Write your own JavaScript stuff here.
//
//##

/*
window.addEventListener('DOMContentLoaded', () => {
 	console.log('Document is ready (site, footer).');
});
*/
